import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { ClientDataBuilder } from './client-data.builder';
import { ClientDataService } from './client-data.service';
import { ClientDataEffects } from './client-data.effects';
import { FEATURE_NAME, reducer } from './client-data.reducer';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { ClientDataDispatcher } from './client-data.dispatcher';
import { ClientDataStore } from './client-data.store';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    EffectsModule.forFeature([ClientDataEffects]),
    StoreModule.forFeature(FEATURE_NAME, reducer),
  ],
})
export class ClientDataModule {
  static forRoot(): ModuleWithProviders<ClientDataModule> {
    return {
      ngModule: ClientDataModule,
      providers: [
        ClientDataDispatcher,
        ClientDataService,
        ClientDataBuilder,
        ClientDataStore,
      ],
    };
  }
}
